<script>
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import {notifyModel} from "@/models/notifyModel";
import {menuModel} from "@/models/menuModel";
import Treeselect from "@riophae/vue-treeselect";

export default {
  page: {
    title: "Danh mục Menu",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Treeselect},
  data() {
    return {
      data: [],
      title: "Menu",
      items: [
        {
          text: "Menu",
          active: true,
        },
        {
          text: "Danh sách",
          active: true,
        }
      ],
      showModal: false,
      showDeleteModal: false,
      submitted: false,
      model: menuModel.baseJson(),
      listParent: [],
      treeView: [],
      itemEvents: {
        mouseover: function () {
        },
        contextmenu: function () {
          arguments[2].preventDefault()
        }
      },
      filter: null,
    };
  },
  validations: {
    model: {
      ten: {required},
    },
  },
  created() {
 //   this.GetPagingParam();
 //    this.GetListParent();
     this.GetTreeList();
  },
  methods: {
    clearSearch(){
      this.filter = null;
    },
    addCoQuanToModel(node, instanceId ){
      if(node.id){
        this.model.parentId = node.id;
      }
    },
    normalizer(node){
      if(node.children == null || node.children == 'null'){
        delete node.children;
      }
    },
    async GetListParent(){
      await this.$store.dispatch("menuStore/getTree").then((res) => {
        this.listParent = res.data;
      })
    },
    async GetTreeList(){
      await this.$store.dispatch("menuStore/getTreeList").then((res) => {
        this.treeView = res.data;
      })
    },
    async GetPagingParam(){
      await this.$store.dispatch("menuStore/getPagingParams").then((res) => {
        this.data = res.data;
      })
    },
    async handleDelete() {
      if (this.model.id != 0 && this.model.id != null && this.model.id) {
        await this.$store.dispatch("menuStore/delete", this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.GetTreeList();
            this.model = menuModel.baseJson();
            this.showDeleteModal = false;
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        });
      }
    },
    handleResetForm() {
      this.model = menuModel.baseJson()
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          // Update model
          await this.$store.dispatch("menuStore/update", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.GetTreeList();
              this.showModal = false;
              this.model = {};
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        } else {
          // Create model
          await this.$store.dispatch("menuStore/create", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.GetTreeList();
              this.showModal = false;
              this.model = menuModel.baseJson();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    async handleUpdate(id) {
      await this.$store.dispatch("menuStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = menuModel.toJson(res.data);
          this.showModal = true;
          this.listParent = this.listParent.filter(x => x.id != id);
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
   async itemClick (node) {
     await this.handleUpdate(node.model.id);
    }
  },
  computed: {

  },
  watch: {
    showModal(status) {
      if (status == false) this.model = menuModel.baseJson();
    },
    model() {
      return this.model;
    },
    showDeleteModal(val) {
      if (val == false) {
        this.model.id = null;
      }
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark">Menu</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button v-b-toggle.collapseSearch variant="light"
                          class="btn w-md btn-primary-outline me-2" size="sm">
                  <i class="fas fa-caret-down align-middle me-2"></i>
                  Tìm kiếm
                </b-button>
              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Nội dung -->
                    <div class="flex-grow-1 me-2">
                      <label>Từ khoá</label>
                      <div class="position-relative">
                        <input
                            v-model="filter"
                            type="text"
                            class="form-control"
                            placeholder="Tìm kiếm ..."
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                    <!--  Xử lý -->
                    <div class="flex-grow-0 ms-2">
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="handleSearch" variant="light"
                                    class="btn w-md btn-primary me-2" size="md">
                            <i class="fas fa-search align-middle me-2"></i>
                            Tìm kiếm
                          </b-button>
                        </div>
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="clearSearch" variant="light"
                                    class="btn w-md btn-secondary me-2" size="md">
                            <i class="fas fa-redo-alt align-middle me-2"></i>
                            Làm mới
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row flex-md-row flex-column-reverse">
      <div class="col-md-6 col-12">
        <div class="card">
          <div class="card-body">
            <v-jstree :data="treeView"   @item-click="itemClick"   :item-events="itemEvents"  ></v-jstree>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="handleSubmit"
                  ref="formContainer"
            >
              <div class="row">
                <div class="col-12">
                  <input type="hidden" v-model="model.id"/>
                  <div class="mb-3">
                    <label class="text-left">Tên menu</label>
                    <input
                        id="ten"
                        v-model="model.ten"
                        type="text"
                        class="form-control"
                        placeholder="Nhập tên menu"
                                            :class="{
                                                      'is-invalid':
                                                        submitted && $v.model.ten.$error,
                                                    }"
                    />
                    <div
                        v-if="submitted && !$v.model.ten.required"
                        class="invalid-feedback"
                    >
                      Tên menu không được trống.
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="text-left">Path</label>
                    <input
                        id="path"
                        v-model="model.path"
                        type="text"
                        class="form-control"
                        placeholder="Nhập path"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="text-left">Action</label>
                    <input
                        id="action"
                        v-model="model.action"
                        type="text"
                        class="form-control"
                        placeholder="Nhập action"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="text-left">Icon</label>
                    <input
                        id="icon"
                        v-model="model.icon"
                        type="text"
                        class="form-control"
                        placeholder="Nhập icon"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="text-left">Menu cha</label>
                    <treeselect
                                        v-on:select="addCoQuanToModel"
                                            :normalizer="normalizer"
                        :options="treeView"
                        :value="model.parentId"
                        :searchable="true"
                        :show-count="true"
                        :default-expand-level="1"

                    >
                      <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                        {{ node.label }}
                        <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                      </label>
                    </treeselect>
                  </div>
                  <div class="mb-3">
                    <label class="text-left">Thứ tự</label>
                    <input
                        id="sort"
                        v-model="model.level"
                        type="number"
                        class="form-control"
                        placeholder="Nhập thứ tự"
                    />
                  </div>
                </div>
              </div>
              <div class="text-end pt-2 mt-3">
                <b-button v-if="model.id" type="button" variant="warning" size="sm" class="ms-1 w-md"
                          v-on:click="handleResetForm"
                > Đặt lại
                </b-button>
                <b-button v-if="model.id" type="button" variant="danger" size="sm" class="ms-1 w-md"
                v-on:click="handleShowDeleteModal(model.id)"
                > Xóa
                </b-button>
                <b-button type="submit" variant="primary" size="sm" class="ms-1 w-md"
                >Lưu
                </b-button>
              </div>
            </form>
            <b-modal
                v-model="showDeleteModal"
                centered
                title="Xóa dữ liệu"
                title-class="font-18"
                no-close-on-backdrop
            >
              <p>
                Dữ liệu xóa sẽ không được phục hồi !
              </p>
              <template #modal-footer>
                <button v-b-modal.modal-close_visit
                        class="btn btn-outline-info m-1"
                        v-on:click="showDeleteModal = false">
                  Đóng
                </button>
                <button v-b-modal.modal-close_visit
                        class="btn btn-danger btn m-1"
                        v-on:click="handleDelete">
                  Xóa
                </button>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
